<div class="modal-header d-flex align-items-center">
  <h6 class="modal-title">{{ title }}</h6>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 
        2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  </button>
</div>
<div class="modal-body text-center">
  <h1 *ngIf="h1">{{ h1 }}</h1>
  <h2 *ngIf="h2">{{ h2 }}</h2>
  <p *ngIf="p">{{ p }}</p>
  <button type="button" class="btn btn-success" (click)="activeModal.close('Close click')">OK</button>
</div>